<template>
  <div class="page-content">
    <!-- 主内容区 -->
    <div class="container-fixed">
      <!-- 头部区域 - 左右分栏布局 -->
      <section id="overview" >
        <div class="flex flex-col lg:flex-row gap-8">
          <!-- 左侧图片轮播区 -->
          <div class="lg:w-3/5">
            <div class="relative h-[600px] rounded-xl overflow-hidden shadow-lg">
              <!-- 轮播图片 -->
              <div class="carousel-slide active h-full w-full">
                <img src="../assets/images/shop/img-1.jpeg" alt="国家会议中心外观" class="w-full h-full object-cover">
              </div>
              <div class="carousel-slide h-full w-full">
                <img src="../assets/images/shop/img-2.png" alt="国家会议中心内部" class="w-full h-full object-cover">
              </div>
              <div class="carousel-slide h-full w-full">
                <img src="../assets/images/shop/img-3.jpg" alt="国家会议中心会议现场" class="w-full h-full object-cover">
              </div>

              <!-- 轮播指示器 -->
              <div class="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
                <div class="carousel-indicator active" data-index="0"></div>
                <div class="carousel-indicator" data-index="1"></div>
                <div class="carousel-indicator" data-index="2"></div>
              </div>

              <!-- 缩略图导航 -->
              <div class="absolute bottom-20 left-0 right-0 flex justify-center space-x-4">
                <div class="thumbnail-indicator active cursor-pointer" data-index="0">
                  <img src="../assets/images/shop/img-1.jpeg" alt="缩略图1" class="w-full h-full object-cover rounded">
                </div>
                <div class="thumbnail-indicator cursor-pointer" data-index="1">
                  <img src="../assets/images/shop/img-2.png" alt="缩略图2" class="w-full h-full object-cover rounded">
                </div>
                <div class="thumbnail-indicator cursor-pointer" data-index="2">
                  <img src="../assets/images/shop/img-3.jpg" alt="缩略图3" class="w-full h-full object-cover rounded">
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧场馆基础信息卡片 -->
          <div class="lg:w-2/5">
            <div class="bg-white/90 backdrop-blur-sm rounded-xl shadow-xl p-8 h-full border border-gray-100">
              <h1 class="text-[clamp(2rem,4vw,3rem)] font-bold text-dark mb-2">国家会议中心</h1>
              <div class="flex flex-wrap items-center gap-4 mb-6">
                <span class="bg-blue-100 text-primary px-4 py-1 rounded-full text-sm font-medium">自营场馆</span>
                <span class="flex items-center text-gray-600"><i class="fas fa-map-marker-alt mr-2 text-red-500"></i>北京市朝阳区天辰东路7号</span>
              </div>

              <!-- 场馆参数 -->
              <div class="grid grid-cols-2 gap-4 mb-8">
                <div class="bg-light rounded-lg p-4 text-center">
                  <div class="text-primary text-3xl font-bold mb-2">270,000<span class="text-lg">㎡</span></div>
                  <div class="text-gray-600">总建筑面积</div>
                </div>
                <div class="bg-light rounded-lg p-4 text-center">
                  <div class="text-primary text-3xl font-bold mb-2">6,400<span class="text-lg">㎡</span></div>
                  <div class="text-gray-600">最大单厅面积</div>
                </div>
                <div class="bg-light rounded-lg p-4 text-center">
                  <div class="text-primary text-3xl font-bold mb-2">53<span class="text-lg">万㎡</span></div>
                  <div class="text-gray-600">总建筑面积</div>
                </div>
                <div class="bg-light rounded-lg p-4 text-center">
                  <div class="text-primary text-3xl font-bold mb-2">2009</div>
                  <div class="text-gray-600">正式运营时间</div>
                </div>
              </div>

              <!-- 功能入口按钮 -->
              <div class="flex flex-col space-y-4">
                <button class="btn-outline-blue py-4 rounded-lg font-medium flex items-center justify-center">
                  <i class="fas fa-vr-cardboard mr-2"></i>VR看馆
                </button>
                <button class="btn-blue py-4 rounded-lg font-medium flex items-center justify-center">
                  <i class="fas fa-calendar-check mr-2"></i>预定场馆
                </button>
                <button @click="openRouter('/hysyd/home')" class="btn-outline-blue py-4 rounded-lg font-medium flex items-center justify-center">
                  <i class="fas fa-globe mr-2"></i>预定会议室
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 场馆介绍 - 统一卡片式布局 -->
      <section id="introduction" class="px-16 py-8">
        <div class="max-w-[100%] mx-auto">
          <div class="section-card">
            <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-8 flex items-center">
              <div class="icon-container icon-container-large mr-3">
                <i class="fas fa-building"></i>
              </div>
              场馆介绍
            </h2>

            <div class="flex flex-wrap mb-12">
              <!-- 场馆概况卡片 -->
              <div class="intro-card">
                <div class="intro-card-header">
                  <i class="fas fa-building"></i>场馆概况
                </div>
                <div class="intro-card-content">
                  <p>国家会议中心由北京北辰实业股份有限公司投资建设，总建筑面积53万平方米。作为2008年奥运会的国际广播中心和主新闻中心所在地，于2009年11月正式运营。场馆深耕标准化建设，服务了万余场会展活动，成为行业标杆场馆。十余年来，国家会议中心已从奥运场馆成长为国家级会展旗舰场馆、高端国事政务活动接待场馆。</p>
                </div>
              </div>

              <!-- 国事服务卡片 -->
              <div class="intro-card">
                <div class="intro-card-header">
                  <i class="fas fa-flag"></i>高端国务政务服务
                </div>
                <div class="intro-card-content">
                  <p>服务保障了2014APEC领导人会议周、亚洲文明对话大会、2022年北京冬奥会和冬残奥会、2024年中非合作论坛峰会、三届"一带一路"国际合作高峰论坛等高端国务和政务活动。场馆始终担负着大国外交的使命与任务，践行着用服务搭起沟通世界桥梁的承诺。</p>
                </div>
              </div>

              <!-- 设施优势卡片 -->
              <div class="intro-card">
                <div class="intro-card-header">
                  <i class="fas fa-tools"></i>设施优势
                </div>
                <div class="intro-card-content">
                  <p>国家会议中心拥有先进的会议设施和完善的服务体系，总建筑面积270,000平方米，最大单厅面积达6,400平方米。场馆配备了现代化的视听设备、智能化的会议系统和专业的技术团队，能够满足各类大型会议、展览、演出等活动的需求。</p>
                </div>
              </div>

              <!-- 服务理念卡片 -->
              <div class="intro-card">
                <div class="intro-card-header">
                  <i class="fas fa-concierge-bell"></i>服务理念
                </div>
                <div class="intro-card-content">
                  <p>国家会议中心秉承"中国服务、国际标准"的品质要求，助力北京"四个中心"功能建设，守正创新，迎接挑战，奔向更加美好的未来。场馆致力于为客户提供卓越的服务体验，打造国际一流的会展平台。</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 会议空间 - 统一卡片式布局 -->
      <section id="spaces" class="px-16 py-8">
        <div class="max-w-[100%] mx-auto">
          <div class="section-card">
            <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-8 flex items-center">
              <div class="icon-container icon-container-large mr-3">
                <i class="fas fa-door-open"></i>
              </div>
              会议空间
              <div @click="openRouter('/fatj/home')" class="fatj-btn btn-blue py-2 rounded-lg font-medium">方案推荐</div>
            </h2>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <!-- 1号展厅 -->
              <div class="space-card bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md">
                <div class="p-6">
                  <h3 class="text-xl font-semibold mb-3">1号展厅</h3>
                  <div class="space-y-2 text-gray-600 mb-4">
                    <p><i class="fas fa-map-marker-alt text-primary mr-2"></i>1F·长宽220×100m·层高12m·灯下高度10m</p>
                    <p><i class="fas fa-expand-arrows-alt text-primary mr-2"></i>面积：5500㎡</p>
                    <p><i class="fas fa-users text-primary mr-2"></i>最多容纳：5000人</p>
                  </div>
                  <div class="mb-4">
                    <h4 class="font-medium text-gray-700 mb-2">布局及容纳人数：</h4>
                    <div class="flex flex-wrap gap-2">
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">剧院式5000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">课桌式2700人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">岛屿式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">酒会式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">U型式2500人</span>
                    </div>
                  </div>
                  <button class="btn-blue w-full py-2 rounded-lg font-medium">
                    模拟摆台
                  </button>
                </div>
              </div>

              <!-- 2号展厅 -->
              <div class="space-card bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md">
                <div class="p-6">
                  <h3 class="text-xl font-semibold mb-3">2号展厅</h3>
                  <div class="space-y-2 text-gray-600 mb-4">
                    <p><i class="fas fa-map-marker-alt text-primary mr-2"></i>1F·长宽220×100m·层高12m·灯下高度10m</p>
                    <p><i class="fas fa-expand-arrows-alt text-primary mr-2"></i>面积：5500㎡</p>
                    <p><i class="fas fa-users text-primary mr-2"></i>最多容纳：5000人</p>
                  </div>
                  <div class="mb-4">
                    <h4 class="font-medium text-gray-700 mb-2">布局及容纳人数：</h4>
                    <div class="flex flex-wrap gap-2">
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">剧院式5000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">课桌式2700人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">岛屿式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">酒会式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">U型式2500人</span>
                    </div>
                  </div>
                  <button class="btn-blue w-full py-2 rounded-lg font-medium">
                    模拟摆台
                  </button>
                </div>
              </div>

              <!-- 3号展厅 -->
              <div class="space-card bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md">
                <div class="p-6">
                  <h3 class="text-xl font-semibold mb-3">3号展厅</h3>
                  <div class="space-y-2 text-gray-600 mb-4">
                    <p><i class="fas fa-map-marker-alt text-primary mr-2"></i>1F·长宽220×100m·层高12m·灯下高度10m</p>
                    <p><i class="fas fa-expand-arrows-alt text-primary mr-2"></i>面积：5500㎡</p>
                    <p><i class="fas fa-users text-primary mr-2"></i>最多容纳：5000人</p>
                  </div>
                  <div class="mb-4">
                    <h4 class="font-medium text-gray-700 mb-2">布局及容纳人数：</h4>
                    <div class="flex flex-wrap gap-2">
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">剧院式5000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">课桌式2700人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">岛屿式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">酒会式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">U型式2500人</span>
                    </div>
                  </div>
                  <button class="btn-blue w-full py-2 rounded-lg font-medium">
                    模拟摆台
                  </button>
                </div>
              </div>

              <!-- 4号展厅 -->
              <div class="space-card bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md">
                <div class="p-6">
                  <h3 class="text-xl font-semibold mb-3">4号展厅</h3>
                  <div class="space-y-2 text-gray-600 mb-4">
                    <p><i class="fas fa-map-marker-alt text-primary mr-2"></i>1F·长宽220×100m·层高12m·灯下高度10m</p>
                    <p><i class="fas fa-expand-arrows-alt text-primary mr-2"></i>面积：5500㎡</p>
                    <p><i class="fas fa-users text-primary mr-2"></i>最多容纳：5000人</p>
                  </div>
                  <div class="mb-4">
                    <h4 class="font-medium text-gray-700 mb-2">布局及容纳人数：</h4>
                    <div class="flex flex-wrap gap-2">
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">剧院式5000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">课桌式2700人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">岛屿式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">酒会式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">U型式2500人</span>
                    </div>
                  </div>
                  <button class="btn-blue w-full py-2 rounded-lg font-medium">
                    模拟摆台
                  </button>
                </div>
              </div>

              <!-- 5号展厅 -->
              <div class="space-card bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md">
                <div class="p-6">
                  <h3 class="text-xl font-semibold mb-3">5号展厅</h3>
                  <div class="space-y-2 text-gray-600 mb-4">
                    <p><i class="fas fa-map-marker-alt text-primary mr-2"></i>0F·长宽209×86m·层高5m·灯下高度4m</p>
                    <p><i class="fas fa-expand-arrows-alt text-primary mr-2"></i>面积：6500㎡</p>
                    <p><i class="fas fa-users text-primary mr-2"></i>最多容纳：5000人</p>
                  </div>
                  <div class="mb-4">
                    <h4 class="font-medium text-gray-700 mb-2">布局及容纳人数：</h4>
                    <div class="flex flex-wrap gap-2">
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">剧院式5000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">课桌式2700人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">岛屿式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">酒会式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">U型式2500人</span>
                    </div>
                  </div>
                  <button class="btn-blue w-full py-2 rounded-lg font-medium">
                    模拟摆台
                  </button>
                </div>
              </div>

              <!-- 6号展厅 -->
              <div class="space-card bg-white border border-gray-200 rounded-xl overflow-hidden shadow-md">
                <div class="p-6">
                  <h3 class="text-xl font-semibold mb-3">6号展厅</h3>
                  <div class="space-y-2 text-gray-600 mb-4">
                    <p><i class="fas fa-map-marker-alt text-primary mr-2"></i>0F·长宽209×100m·层高10m·灯下高度5m</p>
                    <p><i class="fas fa-expand-arrows-alt text-primary mr-2"></i>面积：6500㎡</p>
                    <p><i class="fas fa-users text-primary mr-2"></i>最多容纳：5000人</p>
                  </div>
                  <div class="mb-4">
                    <h4 class="font-medium text-gray-700 mb-2">布局及容纳人数：</h4>
                    <div class="flex flex-wrap gap-2">
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">剧院式5000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">课桌式2700人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">岛屿式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">酒会式2000人</span>
                      <span class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm">U型式2500人</span>
                    </div>
                  </div>
                  <button class="btn-blue w-full py-2 rounded-lg font-medium">
                    模拟摆台
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系方式模块 - 调整为与其他模块一致的标题样式 -->
      <section id="contact" class="px-16 py-8">
        <div class="max-w-[100%] mx-auto">
          <div class="contact-section">
            <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-8 flex items-center">
              <div class="icon-container icon-container-large mr-3">
                <i class="fas fa-envelope"></i>
              </div>
              联系方式
            </h2>

            <div class="contact-container">
              <div class="contact-content">
                <div>
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="fas fa-map-marker-alt"></i>
                    </div>
                    <div class="contact-info">
                      <h4>地址</h4>
                      <p>北京市朝阳区天辰东路7号</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="fas fa-phone-alt"></i>
                    </div>
                    <div class="contact-info">
                      <h4>电话</h4>
                      <p>010-12345678</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="fas fa-fax"></i>
                    </div>
                    <div class="contact-info">
                      <h4>传真</h4>
                      <p>010-12345679</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="fas fa-envelope"></i>
                    </div>
                    <div class="contact-info">
                      <h4>邮箱</h4>
                      <p>info@nmcchina.com</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="fas fa-globe"></i>
                    </div>
                    <div class="contact-info">
                      <h4>官方网站</h4>
                      <p>www.nmcchina.com</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <div class="contact-icon">
                      <i class="fas fa-clock"></i>
                    </div>
                    <div class="contact-info">
                      <h4>工作时间</h4>
                      <p>周一至周日 8:00-22:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 资料下载 - 统一卡片式布局 -->
      <section id="downloads" class="px-16 py-8">
        <div class="max-w-[100%] mx-auto">
          <div class="section-card">
            <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-8 flex items-center">
              <div class="icon-container icon-container-large mr-3">
                <i class="fas fa-file-download"></i>
              </div>
              资料下载
            </h2>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
              <!-- 资料1 -->
              <div class="download-card bg-white rounded-xl shadow-md p-6 border border-gray-200">
                <div class="flex items-center mb-4">
                  <div class="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center text-primary mr-4">
                    <i class="fas fa-file-alt text-2xl"></i>
                  </div>
                  <h3 class="text-lg font-semibold">国家会议中心场馆手册</h3>
                </div>
                <p class="text-gray-600 text-sm mb-4">详细介绍国家会议中心的场馆设施、服务内容及使用指南</p>
                <div class="flex justify-between items-center">
                  <span class="text-xs text-gray-500">PDF · 3.5MB</span>
                  <button class="btn-blue px-4 py-2 rounded-lg text-sm font-medium flex items-center">
                    <i class="fas fa-download mr-2"></i>下载
                  </button>
                </div>
              </div>

              <!-- 资料2 -->
              <div class="download-card bg-white rounded-xl shadow-md p-6 border border-gray-200">
                <div class="flex items-center mb-4">
                  <div class="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center text-primary mr-4">
                    <i class="fas fa-calendar-alt text-2xl"></i>
                  </div>
                  <h3 class="text-lg font-semibold">2026年度展会排期表</h3>
                </div>
                <p class="text-gray-600 text-sm mb-4">2026年国家会议中心全年展会活动安排及时间表</p>
                <div class="flex justify-between items-center">
                  <span class="text-xs text-gray-500">PDF · 1.8MB</span>
                  <button class="btn-blue px-4 py-2 rounded-lg text-sm font-medium flex items-center">
                    <i class="fas fa-download mr-2"></i>下载
                  </button>
                </div>
              </div>

              <!-- 资料3 -->
              <div class="download-card bg-white rounded-xl shadow-md p-6 border border-gray-200">
                <div class="flex items-center mb-4">
                  <div class="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center text-primary mr-4">
                    <i class="fas fa-project-diagram text-2xl"></i>
                  </div>
                  <h3 class="text-lg font-semibold">会议空间技术参数手册</h3>
                </div>
                <p class="text-gray-600 text-sm mb-4">各会议空间的详细技术参数、设备配置及技术服务说明</p>
                <div class="flex justify-between items-center">
                  <span class="text-xs text-gray-500">PDF · 5.2MB</span>
                  <button class="btn-blue px-4 py-2 rounded-lg text-sm font-medium flex items-center">
                    <i class="fas fa-download mr-2"></i>下载
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 交通指南 - 统一卡片式布局 -->
      <section id="traffic" class="px-16 py-8">
        <div class="max-w-[100%] mx-auto">
          <div class="section-card">
            <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-8 flex items-center">
              <div class="icon-container icon-container-large mr-3">
                <i class="fas fa-map-signs"></i>
              </div>
              交通指南
            </h2>

            <div class="space-y-4">
              <div class="traffic-card bg-white/90 p-4 rounded-lg shadow-sm border border-gray-200">
                <h3 class="font-semibold mb-2">国家会议中心站</h3>
                <p class="text-gray-600 text-sm mb-1">143路, 607路, 510路</p>
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-walking mr-1"></i>
                  <span>直线距离269米，步行6分钟</span>
                </div>
              </div>

              <div class="traffic-card bg-white/90 p-4 rounded-lg shadow-sm border border-gray-200">
                <h3 class="font-semibold mb-2">国家体育馆站</h3>
                <p class="text-gray-600 text-sm mb-1">143路, 82路, 607路, 510路</p>
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-walking mr-1"></i>
                  <span>直线距离335米，步行5分钟</span>
                </div>
              </div>

              <div class="traffic-card bg-white/90 p-4 rounded-lg shadow-sm border border-gray-200">
                <h3 class="font-semibold mb-2">洼里南口站</h3>
                <p class="text-gray-600 text-sm mb-1">379路, 466路, 484路, 695路, 319路, 450路</p>
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-walking mr-1"></i>
                  <span>直线距离680米，步行13分钟</span>
                </div>
              </div>

              <div class="traffic-card bg-white/90 p-4 rounded-lg shadow-sm border border-gray-200">
                <h3 class="font-semibold mb-2">机场巴士亚奥国际酒店展</h3>
                <p class="text-gray-600 text-sm mb-1">机场巴士6号线</p>
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-walking mr-1"></i>
                  <span>直线距离1.5公里，步行28分钟</span>
                </div>
              </div>

              <div class="traffic-card bg-white/90 p-4 rounded-lg shadow-sm border border-gray-200">
                <h3 class="font-semibold mb-2">中科院地理所站</h3>
                <p class="text-gray-600 text-sm mb-1">379路, 466路, 484路, 695路, 319路, 450路等</p>
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-walking mr-1"></i>
                  <span>直线距离889米，步行13分钟</span>
                </div>
              </div>

              <div class="traffic-card bg-white/90 p-4 rounded-lg shadow-sm border border-gray-200">
                <h3 class="font-semibold mb-2">北京地铁8号线/15号线奥林匹克公园站</h3>
                <div class="flex items-center text-xs text-gray-500">
                  <i class="fas fa-walking mr-1"></i>
                  <span>直线距离200米，步行2分钟</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 展会日历 - 统一卡片式布局 - 宽度增加至页面80% -->
      <section id="exhibitions" class="px-16 py-8">
        <div class="max-w-[100%] mx-auto">
          <div class="section-card">
            <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-8 flex items-center">
              <div class="icon-container icon-container-large mr-3">
                <i class="fas fa-calendar-alt"></i>
              </div>
              2026年12月展会日历
            </h2>

            <!-- 日历展示 -->
            <div class="bg-white rounded-xl shadow-lg p-8 mb-10 border border-white">
              <div class="flex justify-between items-center mb-6">
                <h3 class="text-xl font-semibold text-primary">2026年12月</h3>
                <div class="flex space-x-2">
                  <button class="p-2 rounded-full hover:bg-gray-100">
                    <i class="fas fa-chevron-left text-gray-600"></i>
                  </button>
                  <button class="p-2 rounded-full hover:bg-gray-100">
                    <i class="fas fa-chevron-right text-gray-600"></i>
                  </button>
                </div>
              </div>

              <!-- 日历网格 -->
              <div class="calendar-grid">
                <!-- 星期标题 -->
                <div class="calendar-header">日</div>
                <div class="calendar-header">一</div>
                <div class="calendar-header">二</div>
                <div class="calendar-header">三</div>
                <div class="calendar-header">四</div>
                <div class="calendar-header">五</div>
                <div class="calendar-header">六</div>

                <!-- 上个月日期 -->
                <div class="calendar-cell calendar-other-month">
                  <span class="calendar-day-number">30</span>
                </div>
                <div class="calendar-cell calendar-other-month">
                  <span class="calendar-day-number">31</span>
                </div>

                <!-- 当月日期 -->
                <div class="calendar-cell">
                  <span class="calendar-day-number">1</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">2</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">3</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">4</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">5</span>
                  <div class="calendar-event-item">中国国际高新技术成果交易会<span class="calendar-event-tag">科技</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">6</span>
                  <div class="calendar-event-item">中国国际高新技术成果交易会<span class="calendar-event-tag">科技</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">7</span>
                  <div class="calendar-event-item">中国国际高新技术成果交易会<span class="calendar-event-tag">科技</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">8</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">9</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">10</span>
                  <div class="calendar-event-item">中国国际汽车工业展览会<span class="calendar-event-tag">汽车</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">11</span>
                  <div class="calendar-event-item">中国国际汽车工业展览会<span class="calendar-event-tag">汽车</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">12</span>
                  <div class="calendar-event-item">中国国际汽车工业展览会<span class="calendar-event-tag">汽车</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">13</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">14</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">15</span>
                  <div class="calendar-event-item">中国国际医疗器械博览会<span class="calendar-event-tag">医疗</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">16</span>
                  <div class="calendar-event-item">中国国际医疗器械博览会<span class="calendar-event-tag">医疗</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">17</span>
                  <div class="calendar-event-item">中国国际医疗器械博览会<span class="calendar-event-tag">医疗</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">18</span>
                  <div class="calendar-event-item">中国国际医疗器械博览会<span class="calendar-event-tag">医疗</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">19</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">20</span>
                  <div class="calendar-event-item">中国国际服装服饰博览会<span class="calendar-event-tag">纺织</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">21</span>
                  <div class="calendar-event-item">中国国际服装服饰博览会<span class="calendar-event-tag">纺织</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">22</span>
                  <div class="calendar-event-item">中国国际服装服饰博览会<span class="calendar-event-tag">纺织</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">23</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">24</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">25</span>
                  <div class="calendar-event-item">中国国际食品添加剂和配料展览会<span class="calendar-event-tag">食品</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">26</span>
                  <div class="calendar-event-item">中国国际食品添加剂和配料展览会<span class="calendar-event-tag">食品</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">27</span>
                  <div class="calendar-event-item">中国国际食品添加剂和配料展览会<span class="calendar-event-tag">食品</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">28</span>
                  <div class="calendar-event-item">中国国际食品添加剂和配料展览会<span class="calendar-event-tag">食品</span></div>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">29</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">30</span>
                </div>
                <div class="calendar-cell">
                  <span class="calendar-day-number">31</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-undef
tailwind.config = {
  theme: {
    extend: {
      colors: {
        primary: '#2563EB',
        secondary: '#204E9C',
        accent: '#60A3BC',
        light: '#F5F7FA',
        dark: '#0C2461'
      },
      fontFamily: {
        sans: ['Inter', 'system-ui', 'sans-serif'],
      },
    }
  }
}
export default {
  name: "Monthly",
  mounted() {
    const root = this.$el; // 当前组件根节点

    // 平滑滚动
    root.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = root.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });

    // 导航栏滚动效果
    window.addEventListener('scroll', function () {
      const nav = document.querySelector('nav'); // 如果 nav 在组件内部，可以改成 root.querySelector('nav')
      if (!nav) return;

      if (window.scrollY > 50) {
        nav.classList.add('bg-white/95', 'backdrop-blur-sm');
        nav.classList.remove('bg-white');
      } else {
        nav.classList.add('bg-white');
        nav.classList.remove('bg-white/95', 'backdrop-blur-sm');
      }
    });

    // 轮播图功能
    const slides = root.querySelectorAll('.carousel-slide');
    const indicators = root.querySelectorAll('.carousel-indicator');
    const thumbnails = root.querySelectorAll('.thumbnail-indicator');
    let currentIndex = 0;

    if (!slides.length) return; // 没有轮播图就直接结束

    // 切换轮播图
    function showSlide(index) {
      // 隐藏所有幻灯片
      slides.forEach(slide => {
        slide.classList.remove('active');
      });

      // 移除所有指示器的 active 状态
      indicators.forEach(indicator => {
        indicator.classList.remove('active');
      });

      // 移除所有缩略图的 active 状态
      thumbnails.forEach(thumbnail => {
        thumbnail.classList.remove('active');
      });

      // 显示当前幻灯片
      slides[index].classList.add('active');

      // 激活当前指示器
      if (indicators[index]) {
        indicators[index].classList.add('active');
      }

      // 激活当前缩略图
      if (thumbnails[index]) {
        thumbnails[index].classList.add('active');
      }

      // 更新当前索引
      currentIndex = index;
    }

    // 点击指示器切换轮播图
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => {
        showSlide(index);
      });
    });

    // 点击缩略图切换轮播图
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        showSlide(index);
      });
    });

    // 自动轮播
    setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }, 5000);
  },
  methods: {
    openRouter(url){
      const { href } = this.$router.resolve({
        path: url,
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}
.fatj-btn{
  position: relative;
  right: 0;
  left: 750px;
  font-size: 20px !important;
  padding: 10px;
}
.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}
@layer utilities {
  .content-auto {
    content-visibility: auto;
  }
  .text-shadow {
    text-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  .card-hover {
    transition: all 0.3s ease;
  }
  .card-hover:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.1);
  }
  .button-gradient {
    background: linear-gradient(135deg, #2563EB 0%, #204E9C 100%);
  }
  .calendar-day {
    aspect-ratio: 1/1;
  }
}
body {
  font-family: 'Inter', system-ui, sans-serif;
  background-color: #F5F7FA;
}

.container-fixed {
  width: 1260px;
  margin: 0 auto;
  overflow: hidden;
}

.nav-shadow {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.carousel-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
}

.carousel-indicator.active {
  width: 24px;
  border-radius: 6px;
  background-color: white;
}

.thumbnail-indicator {
  width: 100px;
  height: 60px;
  opacity: 0.6;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.thumbnail-indicator.active {
  opacity: 1;
  border-color: #2563EB;
}

.space-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.space-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
}

.download-card {
  transition: all 0.3s ease;
}

.download-card:hover {
  background-color: #E8F4F8;
  transform: translateY(-3px);
}

.traffic-card {
  border-left: 4px solid #2563EB;
}

.btn-blue {
  background-color: #2563EB;
  color: white;
  transition: all 0.3s ease;
}

.btn-blue:hover {
  background-color: #1d4ed8;
  transform: translateY(-2px);
}

.btn-outline-blue {
  border: 2px solid #2563EB;
  color: #2563EB;
  transition: all 0.3s ease;
}

.btn-outline-blue:hover {
  background-color: #2563EB;
  color: white;
  transform: translateY(-2px);
}

/* 轮播图动画 */
.carousel-slide {
  transition: opacity 0.5s ease-in-out;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-slide:not(.active) {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}

/* 自定义图标样式 */
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(37, 99, 235, 0.1);
  color: #2563EB;
  font-size: 20px;
}

.icon-container-large {
  width: 48px;
  height: 48px;
  font-size: 24px;
}

/* 统一卡片式布局 */
.section-card {
  background-color: #F5F7FA;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

/* 场馆介绍卡片样式 */
.intro-card {
  background-color: white;
  border-radius: 12px;
  margin-bottom: 1rem;
  border: 1px solid #E0E7FF;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  flex: 1;
  margin-right: 1rem;
}

.intro-card:last-child {
  margin-right: 0;
}

.intro-card-header {
  background-color: #2563EB;
  color: white;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.intro-card-header i {
  margin-right: 8px;
}

.intro-card-content {
  padding: 16px;
  line-height: 1.6;
  color: #333;
  height: 100%;
}

.intro-divider {
  height: 2px;
  background: linear-gradient(90deg, #2563EB 0%, #60A3BC 100%);
  margin: 1.5rem 0;
  border-radius: 1px;
}

/* 简约网格布局的展会日历样式 */
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
}

.calendar-header {
  background-color: #E8F4F8;
  font-weight: 600;
  text-align: center;
  padding: 12px 8px;
  color: #204E9C;
}

.calendar-cell {
  background-color: white;
  min-height: 100px;
  padding: 8px;
  position: relative;
  border: 1px solid #E0E7FF;
  transition: all 0.2s ease;
}

.calendar-cell:hover {
  background-color: #F8FAFC;
  transform: scale(1.02);
  z-index: 10;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.calendar-day-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2563EB;
  margin-bottom: 8px;
  display: block;
}

.calendar-event-item {
  font-size: 14px;
  padding: 4px 6px;
  margin-bottom: 4px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: unset;
  white-space: normal;
  background-color: rgba(37, 99, 235, 0.1);
  color: #2563EB;
  line-height: 1.4;
}

.calendar-event-tag {
  font-size: 12px;
  padding: 1px 4px;
  border-radius: 3px;
  margin-left: 4px;
  background-color: rgba(37, 99, 235, 0.2);
  color: #2563EB;
  display: inline-block;
  margin-top: 2px;
}

.calendar-other-month {
  opacity: 0.4;
}

.calendar-today {
  background-color: #E0F2FE;
  border-color: #0EA5E9;
}

/* 联系我们模块样式 - 调整为与其他模块一致 */
.contact-section {
  background-color: #F5F7FA;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.contact-container {
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
}

.contact-content {
  background-color: white;
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.contact-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(37, 99, 235, 0.1);
  color: #2563EB;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
}

.contact-info h4 {
  font-weight: 600;
  color: #204E9C;
  margin-bottom: 0.25rem;
}

.contact-info p {
  color: #666;
  font-size: 0.95rem;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .container-fixed {
    width: 100%;
  }
}
</style>
